// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MRA4","question":"styles_question__t2Vjx","description":"styles_description__3HF95"};